import './dynamicWebpack';
import 'core-js/stable'; // required polyfills
import initBackboneApp from './src/backbone-unorganized/init';
import attachModulesToWindow from './src/backbone-unorganized/utils/attachModulesToWindow';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { theme } from '@zenput/legacy-ui-components';
import { BentoSnackbarProvider, DialogProvider } from '@zenput/ui-bento';

/**
 * Import our own JS modules and attach them to the window ($f, etc). As our code depends less and less on
 * dependencies living on the window and utilities living on $f, this will become unnecessary. @jira:ZP-3481
 */
attachModulesToWindow(window);

// Have to import the main app.scss to include in the build cycle
// @todo: @author:dem uncomment this when we want to include SCSS in mobile
// import url from '../scss/mobile_bundle.scss';

/**
 * Override jQuerys Ajax to use our extended version
 */
Backbone.ajax = function () {
    return $f.mobile.ajax.apply(Backbone.$, arguments);
};

$f.application = initBackboneApp();

/**
 * Attach a react element to the dom
 *
 * @param node : HTMLElement
 * @param Component: React component
 */
window.mountReactJSX = function (node, Component) {
    const root = ReactDOM.createRoot(node);
    root.render(
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <BentoSnackbarProvider>
                    <DialogProvider>
                        <Component />
                    </DialogProvider>
                </BentoSnackbarProvider>
            </ThemeProvider>
        </StyledEngineProvider>
    );
    // Store the root in a property of the node for later unmounting
    node._reactRoot = root;
};

/**
 * Clean up and remove a react dom element mounted used window.mountReact
 *
 * @param elem : HTMLElement
 */
window.unmountReact = function (elem) {
    if (elem._reactRoot) {
        elem._reactRoot.unmount();
        delete elem._reactRoot;
    }
};
